export default __webpack_public_path__ + "static/media/watch.f2fcc25e.svg";